import { useEffect } from 'react';

import VIDEO_TUTORIAL_STATUS from '@/enums/videoTutorialStatus';
import isFocusElsewhere from '@/utils/functions/isFocusElsewhere/isFocusElsewhere';
import waitForActionButton from '@/utils/functions/waitForActionButton/waitForActionButton';

import type { RefObject } from 'react';

// L'iframe démontée en fin ou en erreur emporte le focus clavier : on le reporte sur l'action proposée,
// sauf si l'utilisateur l'a déjà placé ailleurs.
const useVideoTutorialActionFocus = (containerRef: RefObject<HTMLElement | null>, status: VIDEO_TUTORIAL_STATUS) => {
  useEffect(() => {
    const container = containerRef.current;
    if (!container || (status !== VIDEO_TUTORIAL_STATUS.ENDED && status !== VIDEO_TUTORIAL_STATUS.ERROR)) return;
    if (isFocusElsewhere(container)) return;
    const host = container.querySelector('mtx-button');
    if (!host) {
      container.querySelector('button')?.focus();
      return;
    }
    let isCancelled = false;
    void waitForActionButton(host).then(() => {
      if (isCancelled || isFocusElsewhere(container)) return;
      const button = host.shadowRoot?.querySelector('button') ?? container.querySelector('button');
      button?.focus();
    });
    return () => {
      isCancelled = true;
    };
  }, [status]);
};

export default useVideoTutorialActionFocus;
